import { notifications } from '@mantine/notifications';

import {
  INotifications,
  TNewNotification,
  TNotification,
  TRemovedNotification,
} from '../notifications/core/notifications';

export class AppNotify implements INotifications {
  get messages(): TNotification[] {
    return [];
  }
  get lastMessage(): TNotification {
    return { id: -1, type: 'success', message: '', title: '' };
  }

  addMessage(notification: TNewNotification): void {
    notifications.show({
      color: notification.type === 'error' ? 'red' : 'green',
      title: notification.title,
      message: notification.message,
      autoClose: notification.type === 'error' ? false : undefined,
    });
  }
  removeMessage(notification: TRemovedNotification): void {
    notifications.hide(notification.id.toString());
  }
  clearAll(): void {
    notifications.cleanQueue();
  }
}
